import AntIcon from "@/components/icons/AntIcon";
import { Button, Card, Select, Space, Switch } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DocSignatureStatus, DocSignatureType } from "../../../docsignature/enums";
import { DocSignature } from "../../../docsignature/types";
import { Client } from "../../types";
import { DocumentToSignModalForm } from "../forms/DocumentToSignModalForm";
import { ClientDocumentsToSignTable } from "../tables/ClientDocumentsToSignTable";

type Props = {
  client: Client;
};

export const ClientDocumentsToSign = ({ client }: Props) => {
  const { t } = useTranslation();

  const [isDocumentToSignModalOpen, setIsDocumentToSignModalOpen] = useState(false);
  const [documentToSign, setDocumentToSign] = useState<DocSignature>();
  const [isCreatedStatus, setIsCreatedStatus] = useState(false);
  const [docSignatureType, setDocSignatureType] = useState<DocSignatureType>();

  const resendDocumentToSign = (document: DocSignature) => {
    setDocumentToSign(document);
    setIsDocumentToSignModalOpen(true);
  };

  return (
    <>
      <Card size="small" className="margin-bottom-tiny">
        <Space size="large">
          <div>
            <span className="margin-right-tiny">{t("documentSign.enums.docSignatureType._label")}: </span>
            <Select
              value={docSignatureType}
              style={{ width: 200 }}
              options={Object.values(DocSignatureType).map((item) => ({
                label: t(`documentSign.enums.docSignatureType.${item}`),
                value: item,
              }))}
              allowClear
              placeholder={t("documentSign.helpers.selectDocSignatureType")}
              onChange={setDocSignatureType}
            />
          </div>

          <div>
            <span className="margin-right-tiny">{t("documentSign.helpers.showOnlyCreated")}</span>
            <Switch
              size="small"
              value={isCreatedStatus}
              checkedChildren={<AntIcon type="check" />}
              unCheckedChildren={<AntIcon type="close" />}
              onChange={setIsCreatedStatus}
            />
          </div>
        </Space>
      </Card>

      <ClientDocumentsToSignTable
        clientId={client.id}
        onResend={resendDocumentToSign}
        statusForFilter={isCreatedStatus ? [DocSignatureStatus.CREATED] : undefined}
        typesForFilter={docSignatureType ? [docSignatureType] : undefined}
      />

      <Button
        icon={<AntIcon type="plus" />}
        type="primary"
        className="margin-top-small"
        onClick={() => setIsDocumentToSignModalOpen(true)}
      >
        {t("documentSign.actions.createDocumentToSign")}
      </Button>

      <DocumentToSignModalForm
        isOpen={isDocumentToSignModalOpen}
        onCancel={() => {
          setIsDocumentToSignModalOpen(false);
          setDocumentToSign(undefined);
        }}
        documentToSign={documentToSign}
        client={client}
      />
    </>
  );
};
